import { normalize, schema } from 'normalizr';

const columnEntity = new schema.Entity('columns', {}, { idAttribute: 'accessor' });
const columnSchema = { columns: [columnEntity] };

export function getCollectionRequestData(state) {
  const request = {
    skip: state.page * state.pageSize,
    take: state.pageSize,
  };

  const columns = normalize(state, columnSchema).entities.columns;

  if (state.filtering.length > 0) {
    const filters = [];

    state.filtering.forEach((field) => {
      let value = field.value;
      let operator = 'contains';

      const column = columns[field.id];

      if ('apiRequest' in column) {
        if ('betweenDates' in column.apiRequest && column.apiRequest.betweenDates) {
          if (value && value.startDate) {
            filters.push({
              field: field.id,
              value: value.startDate.toISOString(),
              operator: 'gte',
            });
          }

          if (value && value.endDate) {
            filters.push({
              field: field.id,
              value: value.endDate.toISOString(),
              operator: 'lte',
            });
          }

          return;
        }

        if ('filterTransform' in column.apiRequest) {
          value = column.apiRequest.filterTransform(value);
        }

        if ('operator' in column.apiRequest) {
          if (typeof column.apiRequest.operator === 'function') {
            operator = column.apiRequest.operator(value);
          } else {
            operator = column.apiRequest.operator;
          }
        }
      }

      filters.push({
        field: field.id,
        value,
        operator,
      });
    });

    if (filters) {
      request.filter = {
        filters,
        logic: 'and',
      };
    }
  }


  if (state.sorting.length > 0) {
    const sort = state.sorting.map(field => ({
      field: field.id,
      dir: (field.desc) ? 'desc' : 'asc',
    }));

    request.sort = sort;
  }

  return request;
}



// WEBPACK FOOTER //
// ./src/utils/react-table-helpers.js